import { type AxiosError, isAxiosError } from 'axios';
import { message } from '../message';

// TODO: rename to handleNetworkError
export const handleAxiosError = <T = unknown>(
  error?: AxiosError<T> | Error | null,
  customMessage?: string,
  getErrorMessage?: (error: AxiosError<T>) => string | undefined,
) => {
  const fallbackErrorMessage = customMessage ?? 'Sorry, something went wrong.';

  if (error) {
    if (isAxiosError(error)) {
      if (!error.response && !window.navigator.onLine) {
        message.error('Please check your internet connection.');
        return;
      }

      if (error.response) {
        switch (error.response.status) {
          case 400:
          case 422:
            message.error(getErrorMessage?.(error) ?? fallbackErrorMessage);
            return;
          case 403:
            message.error('Sorry, you are not authorized to perform this action.');
            return;
          case 404:
            message.error('Sorry, resource or target does not exist.');
            return;
          default:
            break;
        }
      }
    }

    message.error(fallbackErrorMessage);
  }
};
